import dispatcher from 'dispatcher';
import Api from 'utils/api';
import * as actionConstants from 'utils/ActionConstants';

export const getPortfolio = async userId => {
    return await Api.getPortfolio(userId);
};

export const getLease = async leaseId => {
    return await Api.getLease(leaseId);
};

export const getCreditApp = async creditAppId => {
    return await Api.getCreditApp(creditAppId);
};



// WEBPACK FOOTER //
// ./src/app/pages/portfolio/PortfolioActions.js